import { render, staticRenderFns } from "./UserBaseInfoEntryPage.vue?vue&type=template&id=0141886b&scoped=true"
import script from "./UserBaseInfoEntryPage.vue?vue&type=script&lang=js"
export * from "./UserBaseInfoEntryPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0141886b",
  null
  
)

export default component.exports